export { MatchRecommendationsContainer as default } from "containers/MatchContainer";
